module.exports = __webpack_public_path__ + "img/form2.82175d4c.jpg";